export default __webpack_public_path__ + "static/media/logo-white.40497b36.png";